import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum DimensionKind {
  NUMERIC = "NUMERIC",
  CATEGORICAL = "CATEGORICAL",
}

const dimensionDefinitionSchema = z.object({
  kind: createEnum(DimensionKind, { enumName: "DimensionKind" }),
  id: z.string(),
  name: z.string(),
  sqlTable: z.string(),
  sqlPath: z.string(),
  sqlPathCalculation: z.string().optional(),
});
export type DimensionDefinition = z.infer<typeof dimensionDefinitionSchema>;

export enum NumericAggregation {
  AVERAGE = "AVERAGE",
}

export enum DimensionRepresentation {
  AXIS = "AXIS",
  COLOR = "COLOR",
}

const dimensionSchema = z.object({
  definitionId: z.string(),
  representation: createEnum(DimensionRepresentation, {
    enumName: "DimensionRepresentation",
  }),
  aggregation: createEnum(NumericAggregation, {
    enumName: "NumericAggregation",
  }).optional(),
});

const filterSchema = z.object({});

export const customVisualSchema = z.object({
  _id: z.string(),
  name: z.string(),

  dimensions: z.array(dimensionSchema),
  filters: z.array(filterSchema),

  createdAt: z.date(),
  updatedAt: z.date(),
});
export type CustomVisual = z.infer<typeof customVisualSchema>;
